exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "loans-detail-purposes .loans-detail-purposes.mobile ul{columns:100px 1;list-style-position:unset;padding-top:0}loans-detail-purposes .loans-detail-purposes.mobile li{font-size:13px}loans-detail-purposes .loans-detail-purposes ul{columns:50px 2;list-style-position:inside;padding-top:14px;padding-left:20px}loans-detail-purposes .loans-detail-purposes li{font-size:15px;padding-top:8px;padding-bottom:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/loansDetail/loansDetailPurposes/loansDetailPurposes.scss
// module id = 1840
// module chunks = 0